<template>
  <div class="gk-period-selector">
    <month-picker-input 
      :default-month="defaultPeriod.month"
      :default-year="defaultPeriod.year"
      :no-default="false"
      :lang="preferredLanguage"
      @change="updateValue"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { MonthPickerInput } from 'vue-month-picker'
export default {
  components: {
    MonthPickerInput,
  },
  props: {
    defaultPeriod: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    ...mapGetters ({ 
      preferredLanguage: 'main/getPreferredLanguage'
    })
  },
  methods: {
    updateValue (selectedDate) {
      this.$emit('input', selectedDate)
    }
  },
}
</script>

<style lang="scss">
.gk-period-selector {
  .month-picker-input-container {
    width: 100%;
    .month-picker-input {
      display: block;
      width: 100%;
      height: calc(1.5em + 0.75rem + 2px);
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid $inputBorderColor;
      border-radius: 6px;
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      cursor: pointer;
    }
    .month-picker__container {
      background: white;
      box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px -1px rgb(0 0 0 / 10%);
      border: 1px solid $inputBorderColor;
      border-radius: 12px;
      overflow: hidden;
      font-family: DINNextLTPro-Regular, sans-serif;
      font-size: 14px;
      top: 2.5rem;
      .month-picker__year, .month-picker {
        background: none;
        border: none;
      }
      .month-picker__year {
        box-shadow: none;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem;
        p { display: block; }
        p, button {
          line-height: 1;
          margin: 0; padding: 0;
        }
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          border-radius: 6px;
          padding: 0;
          width: auto; height: auto;
          left: auto; right: auto;
          top: auto; bottom: auto;
          color: $colorTextBase;
        }
      }
      .month-picker {
        // padding: calc(0.5rem / 2);
        text-shadow: none;
        box-shadow: none;
        border-radius: 0;
        &__month {
          background: white;
          // border: 0;
          border-radius: 0;
          &.selected {
            background-color: $colorBrand;
            color: #ffffff;
            box-shadow: none;
            text-shadow: none;
            &:hover {
              background-color: $colorBrand;
            }
          }
          &:hover {
            background: #22ac8a2e;
            &:after {
              box-shadow: none;
            }
          }
        }
      }
    }
  }
  .month-picker__container {
    z-index: 10;
  }
}

</style>